import EditPayPopup from './EditPayPopup';

export default EditPayPopup;
